// /* global __DEV__  */
import React, { Fragment } from 'react'
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles'
import FormLabel from '@material-ui/core/FormLabel'
import TextField from '@material-ui/core/TextField'
import MomentUtils from '@date-io/moment'
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers'
// material ui icons
import LocalLibrary from '@material-ui/icons/LocalLibrary'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import GridItemCondense from 'components/Grid/GridItemCondense.jsx'
import GridItem from 'components/Grid/GridItem.jsx'
import Card from 'components/Card/Card.jsx'
// import CardContent from 'components/Card/CardContent'
import CardBody from 'components/Card/CardBody.jsx'
import CardHeader from 'components/Card/CardHeader.jsx'
import CardIcon from 'components/Card/CardIcon.jsx'
import CardActions from '@material-ui/core/CardActions'
// should change the name to ...condense as well
import CustomInputCondense from 'components/CustomInput/CustomInputCondense'
import DropdownUsers from '../Components/DropdownUsers'
import Button from 'components/CustomButtons/Button.jsx'

import ReactToPrint from 'react-to-print'

import { isEmpty, pick } from 'lodash'
// style for this view
import requestSubContractorPayment from '../../assets/jss/material-dashboard-pro-react/views/requestSubContractPayment'

import AppContext from '../../services/context'
// import { GAT, GeneralData } from 'staticConfig.js'
// general api service
import {
  insertOne,
  updateOne,
  retrieveDataUsingGraphQL,
  retrieveBoundPath,
  signerResolver,
  getLastLevelOfSingerBasedUponWeight,
  handleApprove,
  handleReject,
  submitApplication,
  isUserInGroup,
  getLastSignerForTOABTA,
} from '../../services/generalServiceAPI'

import Signer from './Signer'
import {
  jsonPP,
  logger,
  titleCase,
  isShowActionButtons,
  isShowSaveButton,
  isShowSubmitButton,
  isShowPrintButton,
  mdy,
  localTime,
  getSingerTitle,
  statusNotAllowToBeModified,
  objectHash,
} from '../utility/utility'
import swal from 'sweetalert2'

import moment from 'moment'

// const timeoffOptions = generateOptionsFromStringArray(GeneralData.typeOfTimeoff)
// printing page design starts from here
const styleOfPrintingForTOA = {
  // @media print and (orientation: [portrait|landscape]) {}
  '@media print': {
    '@page': {
      margin: '0.5cm',
      orientation: 'Portrait',
    },
    margin: '0.5cm',
  },
  //calc("100% - 1cm") doesn't support? the theme is using it, it can be done somehow for sure
  // 表的宽度完全是受 最宽一行影响的，所以 WIDTH OF TABLE is useless, 一定要注意一行里所有 cell加起来的数值
  page: { width: '100%', marginRight: '0.5cm', marginLeft: '0.5cm', marginTop: '1cm', marginBottom: '1cm' },
  table: { borderCollapse: 'collapse', border: '2px solid black', marginBottom: '15px', tableLayout: 'fixed' }, //
  title: { fontSize: '24px', textAlign: 'center', marginBottom: '20px', fontWeight: 'bold' },
  category: { fontSize: '24px', textAlign: 'center', marginBottom: '30px', fontWeight: 'bold' },
  label: { width: '49mm', border: '1px solid black', fontSize: '15px', textAlign: 'left', fontWeight: 'bold', paddingLeft: '5mm' },
  rs5: { rowSpan: 5 },
  value: { width: '49mm', height: '7mm', border: '1px solid black', paddingLeft: '5mm', wordWrap: 'break-word', wordBreak: 'break-all', textAlign: 'left' },
  requestId: { float: 'left', fontSize: '12px', textAlign: 'left', fontWeight: 'bold', clear: 'right' },
  numberValue: { width: '45mm', border: '1px solid black', paddingRight: '10mm', wordWrap: 'break-word', wordBreak: 'break-all', textAlign: 'right' },
  requestor: { width: '197mm', fontSize: '12px', textAlign: 'right', fontWeight: 'bold' },
  comment: { width: '260mm' },
  signer: { width: '60mm' },
  // signers: { position: "absolute", bottom: 0, pageBreakAfter: "always" }
  signers: { pageBreakAfter: 'always', pageBreakInside: 'avoid' },
}
class printingPageOfTOA extends React.Component {
  // const defaultPageStyle = pageStyle === undefined
  // ? "@page { size: auto;  margin: 0mm; } @media print { body { -webkit-print-color-adjust: exact; } }"
  // : pageStyle;
  render = () => {
    const { classes, application } = this.props
    const {
      id,
      name,
      creator,
      createdOn,
      departmentName,
      position,
      vacation,
      //personal,
      sick,
      startDate,
      endDate,
      signers,
      lastLevelToSign,
    } = application

    // const signerWidth = signers.length > 0 && signers.length < 5 ? 45 : 258 / signers.length
    const signerWidth = 48.75
    try {
      return (
        <div className={classes.page}>
          <div className={classes.title}>{'Time Off Application'}</div>
          <div className={classes.requestId}>{'UUID: ' + id.toUpperCase().substr(id.length - 6)} </div>
          <div className={classes.requestor}>{creator ? `${titleCase(creator.name)}, ${localTime(createdOn)}` : ''} </div>
          <table className={classes.table}>
            <tbody>
              <tr>
                <td className={classes.label}>Applicant Name</td>
                <td className={classes.value}>{`${titleCase(name)}`}</td>
                <td className={classes.label}>Position</td>
                <td className={classes.value}>{position}</td>
              </tr>
              <tr>
                <td className={classes.label}>Department</td>
                <td className={classes.value}>{departmentName}</td>
                <td className={classes.label}>Cell</td>
                <td className={classes.value}></td>
              </tr>
              <tr>
                <td className={classes.label}>Requested By</td>
                <td className={classes.value}>{creator ? `${titleCase(creator.name)}` : ''}</td>
                <td className={classes.label}>Requested On</td>
                <td className={classes.value}>{`${mdy(createdOn)}`}</td>
              </tr>
              <tr>
                <td colSpan='4'></td>
              </tr>
              <tr>
                <td className={classes.label} colSpan='4'>
                  Request Details
                </td>
              </tr>
              <tr>
                <td className={classes.label}>Period</td>
                <td className={classes.value} colSpan='3'>{`From ${mdy(startDate)} to ${mdy(endDate)}`}</td>
              </tr>
              <tr>
                <td colSpan='2' className={classes.label}>
                  Type
                </td>
                <td className={classes.label} colSpan='2'>
                  Requested Hours
                </td>
              </tr>
              <tr>
                <td colSpan='2' className={classes.label}>
                  Vacation
                </td>
                <td className={classes.value} colSpan='2'>
                  {vacation}
                </td>
              </tr>
              {/* <tr>
                <td colSpan='2' className={classes.label}>
                  Personal
                </td>
                <td className={classes.value} colSpan='2'>
                  {personal}
                </td>
              </tr> */}
              <tr>
                <td colSpan='2' className={classes.label}>
                  Sick/Dr. Appt
                </td>
                <td className={classes.value} colSpan='2'>
                  {sick}
                </td>
              </tr>
            </tbody>
          </table>{' '}
          <table className={classes.signers}>
            <tbody>
              <tr>
                {signers.slice(0, lastLevelToSign).map((signer, key) => (
                  <td className={classes.signer} style={{ width: `${signerWidth}mm` }} key={`td${key}`}>
                    {signers ? (
                      // <Signer key={`singer${key}`} signer={{ ...signer, role: signingPath.levels[key] ? signingPath.levels[key].approverGroupName : '' }} />
                      <Signer key={`singer${key}`} signer={{ ...signer, role: signers[key] ? signers[key].approverGroupName : '' }} />
                    ) : (
                      ''
                    )}
                  </td>
                ))}
              </tr>
            </tbody>
          </table>
        </div>
      )
    } catch (error) {
      return `<div>${error}</div>`
    }
  }
}
const TOAPrintPage = withStyles(styleOfPrintingForTOA)(printingPageOfTOA)

const initialData = {
  text: {
    title: 'Timeoff Application',
    button: 'Submit',
  },
  data: {
    tableName: 'applications',
    id: '',
    applicant: '',
    name: '',
    departmentName: '',
    position: '',
    vacation: 0,
    personal: 0,
    sick: 0,
    status: 'draft',
    signers: [],
    startDate: moment().format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
    // -1 means for non-saved document, becomes 1 after submition, means the initiator has signed
    activeStep: -1,
    lastLevelToSign: -1, // always assume the initiator will sign first as the first step
  },
  dataState: {},
  // 这个临界值应该从数据库获得，这样用户不需要reload浏览器， 这样不用条件路由，但是不能随意改， 而且有两个assumption
  //  1。 平常用户需要少签一个节点 或者 所有公司的签字路径一样长
  //  2.  每个用户隶属于一个公司， 每个公司有一个路径

  weight_for_regular_users: 50,
}
const fieldsToHash = ['id', 'applicant', 'createdOn', 'vacation', 'personal', 'sick', 'startDate', 'endDate']
class TimeoffApplicationTemplate extends React.Component {
  constructor(props) {
    super(props)

    this.state = initialData

    this.saveApplication = this.saveApplication.bind(this)
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleDropDown = this.handleDropDown.bind(this)
    this.change = this.change.bind(this)
  }

  static contextType = AppContext

  isSubmitted = () => statusNotAllowToBeModified.includes(this.state.data.status)
  isFinished = () => this.state.data.status === 'completed' || this.state.data.status === 'rejected'
  isInputValid = () => {
    const { startDate, endDate, vacation, personal, sick } = this.state.data
    console.log('tttttttt', parseInt(moment.duration(moment(endDate).diff(moment(startDate), 'days')).asDays()) + 1)
    let totalHours = parseInt(vacation) + parseInt(personal) + parseInt(sick)
    return (parseInt(moment.duration(moment(endDate).diff(moment(startDate), 'days')).asDays()) + 1) * 8 >= totalHours && totalHours > 0
  }

  handleDateChange = (id, index = -1) => (date) => {
    const { data } = this.state
    if (index < 0) {
      data[id] = date.toDate()
    } else {
      data[id][index] = date.toDate()
    }
    this.setState({
      data,
    })
  }
  change = (id, index = -1) => (event) => {
    const { data } = this.state
    if (parseInt(event.target.value) < 0) return
    if (index < 0) {
      data[id] = event.target.value
    } else {
      data[id][index] = event.target.value
    }
    logger('[TOA][change]:', data)
    this.setState({
      data,
    })
  }
  // this is only for applicant
  handleDropDown = (id) => (event) => {
    // console.log({ id, event })
    const { data } = this.state
    data[id] = event
    if (id === 'applicant') {
      const { value: initiatorId, company, weight, departmentName, position } = this.state.data.applicant
      data['departmentName'] = departmentName
      data['position'] = position
      this.loadPathInfo(initiatorId, company, weight)
    }
    this.setState({ data })
  }
  async loadPathInfo(initiatorId, company, weight) {
    if (isEmpty(company) || isEmpty(company.id)) {
      logger(logger('[TOA][loadPathInfo]', this.state.data))
      return
    }
    const {
      data: { pathBinding },
    } = await retrieveBoundPath({ typeOfApplicationId: 1, companyId: company.id })

    // 2) resolve signers
    if (isEmpty(pathBinding)) {
      // this is not an error, just means no routes yet
      this.setState({
        data: {
          ...this.state.data,
          routes: [],
          signers: [],
        },
      })

      swal.fire({
        title: 'No signing path found!',
        html: `There is no signing path designed for Timeoff Application in <b>[${company.name}]</b> , please have your administrator to construct signing path first please.`,
        type: 'warning',
      })
    } else {
      logger('[TOA][loadPathInfo][1]', pathBinding)
      let signers = await signerResolver(pathBinding[0].signingPath, initiatorId)
      let lastLevelToSign = -1
      const levelsOfManager = await getLastLevelOfSingerBasedUponWeight(this.state.data.applicant.weight, signers.length)
      const HRSignerGroupName = 'HR-' + this.state.data.applicant.company.country
      const HRSignerPreApproverGroupName = 'HR-' + this.state.data.applicant.company.country + '-PREAPPROVE'
      const HRSigner = isEmpty(this.state.data.applicant.company.country) ? [] : await getLastSignerForTOABTA(HRSignerGroupName)
      const HRSignerPreApprover = isEmpty(this.state.data.applicant.company.country) ? [] : await getLastSignerForTOABTA(HRSignerPreApproverGroupName)
      logger('[TOA][loadPathInfo][2]', { signers, HRSigner, HRSignerPreApprover, levelsOfManager, lastLevelToSign })
      if (isEmpty(HRSigner)) {
        lastLevelToSign = levelsOfManager
      } else {
        //lastLevelToSign = levelsOfManager + 1
        // 改成加2， 因为前面加了一级签字
        lastLevelToSign = levelsOfManager + 2
        signers.splice(levelsOfManager)
        if (!isEmpty(HRSignerPreApprover)) {

          signers.unshift({
            id: HRSignerPreApprover.id,
            level: 1,
            position: '',
            fullName: HRSignerPreApprover.name,
            email: HRSignerPreApprover.email,
            approverGroupName: 'HR Pre Approver'
          })
          signers.map((signer, key) => signer.level = key + 1)
        }
        //const { id, position = '', name: fullName, email } = HRSigner
        signers.push({
          id: HRSigner.id,
          level: lastLevelToSign,
          position: '',
          fullName: HRSigner.name,
          email: HRSigner.email,
          approverGroupName: HRSignerGroupName
        })
      }
      this.setState({
        data: {
          ...this.state.data,
          // lastLevelToSign: weight >= this.state.weight_for_regular_users ? signers.length : signers.length - 1,
          lastLevelToSign,
          signers,
          signingPathId: pathBinding[0].signingPath.id,
          signingPath: pathBinding[0].signingPath,
        },
      })
    }
  }

  loadApplicationDetail = async (id) => {
    const query = `
    query TOA($id: ID!){
      application(id: $id) {
        id
        creatorId
        creator{
          id
          name
          email
          company{
            id
            name
            country
          }
        }
        createdOn
        lastModifiedOn
        name
        departmentName
        position
        status
        signers {
          id
          level
          position
          fullName
          chineseName
          action
          email
          signedOn
        }
        signingPath{
          levels{
            approverGroupName
          }
        }
        startDate
        endDate
        vacation
        personal
        sick
        activeStep
        lastLevelToSign
        type {
          id
          name
          description
          short
        }
      }
    }
  `
    await retrieveDataUsingGraphQL(query, { id })
      .then(async (response) => {
        if (response.status === 200) {
          return response.json()
        } else {
          throw new Error(JSON.stringify(await response.json()))
        }
      })
      .then(({ data }) => {
        if (isEmpty(data)) throw new Error('Unable to fetch application details.')
        // Based upon the application type, load data accordingly
        logger('[TOA][loadApplicationDetail]:', data)
        // this.parseApplicationData(data)
        const { creator, name, ...rest } = data.application
        this.setState({
          text: {
            title: 'TOA Application',
          },
          initiatorId: creator.id,
          data: {
            ...this.state.data,
            name,
            creator,
            applicant: {
              label: name,
              value: creator.id,
              country: creator.company.country,
            },
            ...rest,
          },
        })
      })
      .catch((e) => {
        logger('[TOA][loadApplicationDetail]:', e, true)
        swal.fire({ title: 'Error in TOA', html: e.message, type: 'error' }).then((v) => this.props.history.push('/dashboard'))
      }) //error report
  }
  componentWillUnmount() {
    this.context.applicationId = ''
  }
  //pick up all the predefined conditional fields, the key should align with
  async componentDidMount() {
    // console.log(this.context.user)
    let query
    let initiatorId = this.context.user ? this.context.user.id : ''

    if (this.props.match.params.id) {
      //this await is necessary, otherwise the activeStep in next step will be unavailable
      await this.loadApplicationDetail(this.props.match.params.id)
      // console.log(this.state.data)
    }
    if (isEmpty(this.state.data.id) || this.state.data.activeStep < 0) {
      // see BTA for logic
      query = `
        query typeOfApplication($id: Int!){
          typeOfApplication(id: $id) {
            id
            name
            description
            short
          }
        }
      `
      await retrieveDataUsingGraphQL(query, { id: 1 })
        .then((response) => response.json())
        .then(({ data }) => {
          let departmentName
          if (isEmpty(this.context.user.department)) {
            logger('[TAO][retrieveDataUsingGraphQL][1]', `Missing department info for ${this.context.user.fullName}.`, true)
          } else {
            // departmentId = this.context.user.department.id
            departmentName = this.context.user.department.name
          }
          const { id, name, position, company, weight } = this.context.user
          this.setState({
            text: {
              title: 'TOA Application',
            },
            initiatorId,
            data: {
              ...this.state.data,
              type: data.typeOfApplication,
              name,
              applicant: {
                label: name,
                value: id,
                company,
                weight,
              },
              position: isEmpty(position) ? '' : position.name,
              company,
              departmentName,
            },
          })
        })
        .catch((e) => {
          logger('[TOA][componentDidMount] - ', e.message, true)
        })
      if (isEmpty(this.state.data.signers)) {
        const { value: initiatorId, company, weight } = this.state.data.applicant
        await this.loadPathInfo(initiatorId, company, weight)
      }
    }
    // get hash code
    this.setState({
      isHRAdmin: await isUserInGroup(this.context.user.id, 'SYSTEM-HR'),
      hash: objectHash(pick(this.state.data, fieldsToHash)),
    })
  }

  saveApplication(isSubmitApplication) {
    try {
      if (isSubmitApplication && isEmpty(this.state.data.signers)) throw new Error('Failed to submit , no signers available.')
      if (this.isInputValid()) {
        //noError(this.state.dataState
        const { data } = this.state
        const {
          // remove the following before save,
          routes,
          creator,
          signingPath,
          signingPathId,
          applicant,
          // modify the following before save
          name,
          signers,
          creatorId,
          // keep the rest
          lastLevelToSign,
          ...keptData
        } = data

        const dataToSave = {
          signers: (() => {
            //check if all the signers exist only when submit
            if (isSubmitApplication) {
              if (isEmpty(signers)) {
                throw new Error('Does not know how to route this applicaiton yet, please consult your administrator.')
              } else if (
                signers.slice(0, lastLevelToSign - 1).reduce((agg, signer) => {
                  return agg || isEmpty(signer.id)
                }, false)
              ) {
                throw new Error(
                  'Missing a signer currently, it might be caused by temprarily no one available in a department or group or due to some system settings, please make your administrator be aware of this situation, it might be better just to take a screenshot to email to them.'
                )
              } else {
                return signers
              }
            }
          })(), // only save signers when isSubmitApplication
          lastLevelToSign,
          ...keptData,
          archived: false,
          //prevent someone else override the original initiator
          name: applicant.label,
          creatorId: isEmpty(creatorId) ? applicant.value : creatorId,
        }
        logger('[TOA][saveApplication]:', dataToSave)
        const insertOrModify = data.id && data.id !== '' ? updateOne : insertOne

        // feels like the first then() and catch() could be moved into general service
        insertOrModify(dataToSave)
          .then((response) => {
            if (response.ok) {
              return response.json()
            } else swal.fire({ title: 'Error', html: response.url, type: 'error' })
          })
          .then(async (res) => {
            //  logger('BTA: saveApplication',res)
            const { id } = res
            const recordId = id ? id : this.state.data.id
            // const creatorName = titleCase(this.context.user.firstname + ' ' + this.context.user.lastname)
            // const creator = { id: this.context.user.id, name: creatorName, email: this.context.user.email }
            // await swal.fire({ title: 'Success', html: 'This record has beend saved - ' + recordId, timer: 2000, type: 'success' })
            if (isSubmitApplication) {
              submitApplication({
                application: { ...this.state.data, id, creator, submitter: creator.id === this.context.user.id ? '' : this.context.user.name },
              }).then(async (data) => {
                logger('[TOA][saveApplication]:', { data })

                if (data.code !== 0) {
                  swal.fire({ title: 'Error', html: data.message, type: 'error' })
                } else {
                  await this.loadApplicationDetail(recordId)
                  await swal.fire({ title: 'Success', html: 'This record has beend submitted - ' + recordId, timer: 2000, type: 'success' })
                  this.setState({
                    hash: objectHash(pick(this.state.data, fieldsToHash)),
                  })
                }
              })
            } else {
              // only show save success message for saving draft, so just 1 message per action
              await swal.fire({ title: 'Success', html: 'This record has beend saved - ' + recordId, timer: 2000, type: 'success' })
              await this.loadApplicationDetail(recordId)
              // load 要把 stataus, creator info 加回来

              const data = {
                ...this.state.data,
                signers,
              }
              this.setState({
                data,
                hash: objectHash(pick(data, fieldsToHash)),
              })
            }
          })
        // .catch(e => swal('Error', `General API throw error: ${e}`), 'error')
      } else {
        swal.fire({ title: 'Error in TOA', html: 'Making sure the input make sense.', type: 'error' })
      }
    } catch (e) {
      logger('[TOA][saveApplication]:', e, true)
      swal.fire({ title: 'Error in TOA', html: e.message, type: 'error' })
    }
  }

  render() {
    const { classes } = this.props
    const getCornerInfo = () =>
      !isEmpty(this.state.data.id)
        ? `UUID: ${this.state.data.id.toUpperCase().substr(this.state.data.id.length - 6)} [${titleCase(this.state.data.creator.name)}]`
        : ''

    const dateInput = (id, index = -1, disabled = false) => {
      return (
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DatePicker
            //inputProps={{ style: { marginLeft: '35px' } }} #hange input style inside div
            style={{ marginLeft: '15px' }}
            disableToolbar
            variant='inline'
            format='MM/DD/YYYY'
            // label='date'
            disabled={disabled || this.isSubmitted()}
            placeholder='MM/DD/YYYY'
            value={index > -1 ? (isNaN(this.state.data[id][index]) ? null : this.state.data[id][index]) : this.state.data[id]}
            autoOk={true}
            onChange={this.handleDateChange(id, index)}
          />
        </MuiPickersUtilsProvider>
      )
    }

    const numberInput = (id, disabled = false) => {
      return (
        <TextField
          id={id}
          style={{ marginLeft: '15px' }}
          formControlProps={{
            fullWidth: true,
          }}
          disabled={disabled || this.isSubmitted()}
          onChange={this.change(id, -1)}
          inputProps={{
            // onChange: event => this.change('airTicket', -1),
            onChange: this.change(id, -1),
            value: this.state.data[id],
            type: 'number',
          }}
        />
      )
    }
    return (
      <div>
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color='rose' icon>
                <CardIcon color='rose'>
                  <LocalLibrary />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>{this.state.text.title}</h4>
              </CardHeader>
              <CardBody>
                <form>
                  <GridContainer>
                    {/** row 1   */}
                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Name</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={3}>
                      <DropdownUsers
                        id='applicant'
                        isDisabled={this.isSubmitted() || !this.state.isHRAdmin}
                        value={this.state.data.applicant}
                        onChange={this.handleDropDown('applicant')}
                      />
                    </GridItemCondense>
                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Position</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={3}>
                      <CustomInputCondense
                        id='position'
                        disabled={true}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: this.state.data.position,
                          type: 'text',
                        }}
                      />
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** row 2   */}

                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Department</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={8}>
                      <CustomInputCondense
                        id='department'
                        disabled={true}
                        formControlProps={{
                          fullWidth: true,
                        }}
                        inputProps={{
                          value: this.state.data.departmentName,
                          type: 'text',
                        }}
                      />
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={2} />
                    {/** row 3   */}
                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Date of Request</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={4}>
                      {dateInput('createdOn', -1, this.isSubmitted() || !this.state.isHRAdmin)}
                    </GridItemCondense>
                    {/*  这个太奇怪， 2+2+4+5=13? */}
                    {/* 下面这个 12 列的空行非常重要 */}
                    <GridItemCondense xs={12} md={5} />
                    {/** row 4   */}
                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Start from </FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={2}>
                      {dateInput('startDate')}
                    </GridItemCondense>
                    <GridItemCondense xs={4} md={1}>
                      <FormLabel className={classes.labelCondense}>to</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={2}>
                      {dateInput('endDate')}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={5} />
                    {/** row 5   */}
                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Vacation(hrs)</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={1}>
                      {numberInput('vacation')}
                    </GridItemCondense>

                    <GridItemCondense xs={12} md={9} />
                    {/** row 6   */}
                    {/* delete as per Jeremy */}
                    {/* <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Personal(hrs)</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={1}>
                      {numberInput('personal')}
                    </GridItemCondense> */}
                    {/* 
                    <GridItemCondense xs={12} md={9} /> */}
                    {/** row 7  */}
                    <GridItemCondense xs={4} md={2}>
                      <FormLabel className={classes.labelCondense}>Sick/Dr. Appt(hrs)</FormLabel>
                    </GridItemCondense>
                    <GridItemCondense xs={8} md={1}>
                      {numberInput('sick')}
                    </GridItemCondense>
                    <GridItemCondense xs={12} md={9} />
                    {/** line of singers */}
                    {this.state.data.signers
                      .sort((a, b) => a.level - b.level)
                      .map((signer, key) =>
                        signer.level <= this.state.data.lastLevelToSign ? (
                          <GridItem key={`singer-grid${key}`} xs={6} md={2}>
                            <Signer
                              key={`singer${key}`}
                              signer={{
                                ...signer,
                                role: getSingerTitle(signer, key, this.state.data.signingPath),
                                // this.state.data.signingPath && this.state.data.signingPath.levels[key]
                                //   ? this.state.data.signingPath.levels[key].apprverType === 1
                                //     ? 'R'
                                //     : this.state.data.signingPath.levels[key].approverGroupName
                                //   : ''
                              }}
                            />
                          </GridItem>
                        ) : (
                          ''
                        )
                      )}
                  </GridContainer>
                </form>
              </CardBody>
              <CardActions className={classes.actions}>
                <FormLabel className={classes.labelCondense}>{getCornerInfo()}</FormLabel>
                {isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? (
                  <Button color='rose' style={{ marginLeft: 'auto' }} onClick={() => this.saveApplication(false)}>
                    Save
                  </Button>
                ) : (
                  ''
                )}

                {isShowSubmitButton(this.state.data, this.context.user.id, this.state.isHRAdmin) ? (
                  <Button
                    color='rose'
                    style={isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? {} : { marginLeft: 'auto' }}
                    onClick={() => this.saveApplication(true)}
                  >
                    Submit
                  </Button>
                ) : (
                  ''
                )}
                {/* 同意/拒绝按钮 */}
                {isShowActionButtons(this.state.data, this.context.user.id) ? (
                  <Fragment>
                    <Button
                      color='rose'
                      style={{ marginLeft: 'auto' }}
                      onClick={() =>
                        handleApprove({ application: this.state.data, refresh: this.loadApplicationDetail, pullingNumbers: this.context.pullingNumbers })
                      }
                    >
                      Approve
                    </Button>
                    <Button
                      color='rose'
                      onClick={() =>
                        handleReject({ application: this.state.data, refresh: this.loadApplicationDetail, pullingNumbers: this.context.pullingNumbers })
                      }
                    >
                      Reject
                    </Button>
                  </Fragment>
                ) : (
                  ''
                )}
                {/* 打印按钮 */}
                {this.state.data.id !== '' ? (
                  <ReactToPrint
                    trigger={() => (
                      <Button
                        color='rose'
                        // style={isShowSaveButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash) ? {} : { marginLeft: 'auto' }}
                        // className={['rejected', 'completed', 'submitted'].includes(this.state.data.status) ? classes.buttons : ''}
                        style={
                          isShowPrintButton(pick(this.state.data, fieldsToHash), this.context.user.id, this.state.hash)
                            ? { marginLeft: 'auto' }
                            : { marginLeft: 'unset' }
                        }
                      // onClick={() => handlePrint({ application: this.state.data })}
                      >
                        Print
                      </Button>
                    )}
                    content={() => this.componentRef}
                    pageStyle='@page { size: auto;  margin: 5mm; }'
                  />
                ) : (
                  ''
                )}
              </CardActions>
            </Card>
          </GridItem>
          <div style={{ display: 'none' }}>
            <TOAPrintPage application={this.state.data} ref={(el) => (this.componentRef = el)} />
          </div>
        </GridContainer>
        {jsonPP(this.context)}
        {jsonPP(this.state)}
      </div>
    )
  }
}

export default withStyles(requestSubContractorPayment, { withTheme: true })(TimeoffApplicationTemplate)
